import axios from "axios";

function getTransactions(name, callback) {
    console.log("getTransactions()")
    const url = "https://us-east-1.aws.data.mongodb-api.com/app/dfin_app-rnwhu/endpoint/getTransactions";
    const conn_string = url + "?name="+name;
    console.log("conn_string = ", conn_string)
    axios
        .get(conn_string)
        .then((response) => {
            if (callback) {
                callback(response.data)
            }
        })
        .catch(function (error) {
            // console.log(error);
            callback(null)
        });
}

function dummy(data) {
    console.log("dummy, data=", data)
}

function remove_specials(in_string, specs=":/?#[]@!$&'()*+,;=") {
    var out_string = in_string;
    specs.split('').forEach( (p) => {out_string = out_string.replace(p, " ")})
    return out_string
}


function saveTransactions_callback(name, transactions, favorites, callback=dummy) {
    console.log("saveTransactions_callback: name=", name)
    const url = "https://us-east-1.aws.data.mongodb-api.com/app/dfin_app-rnwhu/endpoint/saveTransactions";
    var conn_string = url
    conn_string = conn_string + "?name="+name
    const comment = transactions.map( (t) => t.comment.replace("#","").replace("&",""))
    conn_string = conn_string + "&comment=" + remove_specials(JSON.stringify(comment))

    const sum=transactions.map( (t) => t.sum)
    conn_string = conn_string + "&sum=" + JSON.stringify(sum)

    const date=transactions.map( (t) => t.date.toString().substr(4, 12))
    conn_string = conn_string + "&date=" + JSON.stringify(date)

    var favs=JSON.stringify(favorites)
    conn_string = conn_string + "&favs="+remove_specials(favs);
   
    axios
        .get(conn_string)
        .then((response) => {
            if (callback) {
                callback(response.data)
            }
        })
        .catch(function (error) {
            console.log(error);
            //callback(null)
        });
}


function saveTransactions(name, transactions, favorites) {
    console.log("saveTransactions")

    console.log("deleting ", name)
    var url = "https://us-east-1.aws.data.mongodb-api.com/app/dfin_app-rnwhu/endpoint/deleteTransactions?name="+name
    axios
        .get(url)
        .then((response) => {
            saveTransactions_callback(name, transactions, favorites)
        })
        .catch(function (error) {
            console.log(error);
        });
    return;
}

export {
    getTransactions, saveTransactions
}